import type { UserPayload } from "@/shared/types";
import { jwtDecode } from "jwt-decode";

export const decodeJwt = (access_token: string) => {
  return jwtDecode(access_token) as UserPayload;
};
